import { t } from 'i18next'

export const AllRestaurantFilterData = [
    {
        id: 0,
        name: t('Veg'),
        value: 'veg',
        isActive: false,
    },
    {
        id: 1,
        name: t('Non-Veg'),
        value: 'non_veg',
        isActive: false,
    },
    {
        id: 2,
        name: t('Top Rated'),
        value: 'top_rated',
        isActive: false,
    },
    {
        id: 3,
        name: t('Discount'),
        value: 'discount',
        isActive: false,
    },
]
